<div class="sxw-step" *ngIf="!hidden && (active || parent?.scrollableMode)">
  <div *ngIf="parent?.scrollableMode" class="scrollable-mode-step-header">
    <h3>{{ stepCustomName ? stepCustomName : stepName | translate}}</h3>
    <sxw-svg-icon [name]="'checked'" class="step-icon"  width="15" height="15">
    </sxw-svg-icon>
  </div>
  <ng-content></ng-content>
</div>
